// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PCWmzm1TMmsWWSY1eoUs{background:var(--background-primary-inverted-primary);border-radius:32px;width:254px;height:486px;padding:8px;display:flex;box-shadow:inset 0 -2px 12px rgba(169,180,188,.6)}.DAjU3HqGTxUDm7ogNpJ4{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:32px;flex-grow:1;display:flex;overflow:hidden}.YNRcNh5qwbQ09m1ZfSwa{border-radius:12px;flex-grow:1;display:flex;overflow:auto}.eextILHQjjE28qryjSSx{flex-direction:column;gap:8px;display:flex}.AQnxGVKxJc24raC1CDpE{justify-content:flex-start;align-items:center;gap:6px;height:44px;display:flex}.JseJj32aTEowlr6TSpC5{padding:0 12px;box-shadow:0 1px 2px rgba(18,21,23,.12)}.IteDho43weEWoyBF3Xnp{flex-direction:column;gap:8px;padding:12px;display:flex}.uhIzuun_XswExpYvsxtr{background:var(--background-brand-subtle-primary);color:var(--content-neutral-primary);border-radius:12px;max-width:200px;padding:12px}.IqAYAi0npJwkYJYmRy58{background:var(--background-neutral-default)}.U4s9J5GTU4A5TkKIRD9i{width:186px;height:auto;padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `PCWmzm1TMmsWWSY1eoUs`,
	"preview__layer": `DAjU3HqGTxUDm7ogNpJ4`,
	"previewLayer": `DAjU3HqGTxUDm7ogNpJ4`,
	"preview__layerWrap": `YNRcNh5qwbQ09m1ZfSwa`,
	"previewLayerWrap": `YNRcNh5qwbQ09m1ZfSwa`,
	"preview__content": `eextILHQjjE28qryjSSx`,
	"previewContent": `eextILHQjjE28qryjSSx`,
	"preview__header": `AQnxGVKxJc24raC1CDpE`,
	"previewHeader": `AQnxGVKxJc24raC1CDpE`,
	"preview__headerWrap": `JseJj32aTEowlr6TSpC5`,
	"previewHeaderWrap": `JseJj32aTEowlr6TSpC5`,
	"preview__messages": `IteDho43weEWoyBF3Xnp`,
	"previewMessages": `IteDho43weEWoyBF3Xnp`,
	"preview__message": `uhIzuun_XswExpYvsxtr`,
	"previewMessage": `uhIzuun_XswExpYvsxtr`,
	"preview__messageOutbound": `IqAYAi0npJwkYJYmRy58`,
	"previewMessageOutbound": `IqAYAi0npJwkYJYmRy58`,
	"preview__messageWithImage": `U4s9J5GTU4A5TkKIRD9i`,
	"previewMessageWithImage": `U4s9J5GTU4A5TkKIRD9i`
};
export default ___CSS_LOADER_EXPORT___;
